enum SaveOnExitModalOptionsEnum {
	CANCEL = 'CANCEL',
	DISCARD = 'DISCARD',
	SAVE = 'SAVE'
}

export type SaveOnExitModalOptions = keyof typeof SaveOnExitModalOptionsEnum;
